import { useParams } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { ApprovalDocView } from './doc/ApprovalDocView';
import './ApprovalPage.css';

/**
 * 문서 하나를 여는 **자리** — `/approval/doc/:id` (2026-09-07 · 시안 A2 각주 6).
 *
 * ── 왜 주소가 하나 늘었나 ────────────────────────────────────────────────
 * 문서함(`ApprovalDocsPage`)은 **왼쪽 목록 · 오른쪽 상세** 두 열이라 고른 문서가 그 화면 안에
 * 머문다. 그런데 결재 홈에는 목록이 **셋**(카드 · 진행 문서 · 완료 문서)이라 그 방식이 안 맞는다 —
 * 사용자 지정: *「선택하면 상세 페이지로 페이지가 이동한다.」*
 *
 * ★★ **문서함의 두 열 배치는 그대로 둔다**(회귀 0). 상세 «내용»은 같은 컴포넌트
 *    (`ApprovalDetail`)를 쓴다 — 두 벌로 만들면 언젠가 한쪽만 고쳐진다.
 * ★ 셸 안의 자리라 트리를 인 채로 열린다.
 * ★★ 2026-09-14(과제 L3 · 시안 axi-approval-detail v2) — 이 자리의 내용은 새 `doc/ApprovalDocView` 다
 *    (머리 카드 · 본문/결재선/첨부/의견/이력 탭 · 결재 막대). 옛 `ApprovalDetail` 은 문서함 두 열 화면(`legacy/*`)에 그대로 남는다.
 */
export function ApprovalDocPage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const userId = useAuthStore((s) => s.user?.id?.toString() ?? '');

  if (!id) {
    return (
      <div className="approval-page__main">
        <p className="approval-page__hint">문서를 찾을 수 없습니다.</p>
      </div>
    );
  }

  // ★ 「뒤로」 · 제목(결재 문서) · 결재함으로 가기는 새 화면 머리에 있다(ApprovalDocView).
  // ★ key={id} (2026-09-13 · #1205 후속) — 같은 경로 안에서 다른 문서로 가면 새로 그린다.
  //   없으면 컴포넌트가 재사용돼 앞 문서의 상태(실패 줄 actionError · 의견 · 탭)가 남는다.
  return <ApprovalDocView key={id} documentId={id} currentUserId={userId} />;
}
